import { Component, Inject, OnInit, Optional } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from '~/app/core/configs/constants';
import { AdminService, SwalService } from '~/app/core/services';

@Component({
  selector: 'app-shared-regulatory-detail',
  templateUrl: './regulatory-detail.component.html',
  styleUrls: ['./regulatory-detail.component.scss']
})
export class RegulatoryDetailComponent implements OnInit {

  form: FormGroup;
  requests: any = [];
  reqPageSize = 5;
  reqPageOffset = 0;
  reqTotal = 0;
  histories: any = [];
  historiesPageSize = 10;
  historiesPageOffset = 0;
  historiesTotal = 0;
  displayColRequest: string[] = [
    'index',
    'date',
    'uen',
    'tradeweb_id',
    'from',
    'to',
    'status',
  ];

  displayColHistories: string[] = [
    'index',
    'date',
    'update',
    'status',
    'comment',
  ];

  defaultSort = 'created_date DESC';
  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data
  ) { }

  get uen(): AbstractControl {
    return this.form.get('uen');
  }
  get tradeweb_id(): AbstractControl {
    return this.form.get('tradeweb_id');
  }
  async ngOnInit(): Promise<void> {
    this.createForm();
    this.getRegulatoryFiling(this.reqPageOffset, this.reqPageSize, this.defaultSort);
    this.getRegulatoryHistories(this.historiesPageOffset, this.historiesPageSize, this.defaultSort);
    if (this.data) {
      const { status } = this.data;
      const statusPatchForm = [Constants.RegulatoryStatus.FOR_VALIDATION, Constants.RegulatoryStatus.ACCEPTED];
      if (statusPatchForm.includes(status)) {
        this.form.patchValue(this.data);
      }
      if (status === Constants.RegulatoryStatus.ACCEPTED) {
        this.form.disable();
      }
    }
  }
  createForm(): void {
    const formGroupObj: any = {
      uen: [null, [Validators.required]],
      tradeweb_id: [null, Validators.required],
    };
    this.form = this.fb.group(formGroupObj);
  }

  getRegulatoryFiling(offset, size = 5, sort = '') {
    let _params = {
      offset: offset,
      limit: size,
      sort
    }
    this.adminService.getRegulatoryFiling(_params).subscribe(res => {
      this.requests = res.data;
      this.reqTotal = res.total;
    }, error => {
      let mes = error.message ? error.message : error;
      SwalService.error(mes);
    })
  }
  getRegulatoryHistories(offset, size = 10, sort = '') {
    let _params = {
      offset: offset,
      limit: size,
      sort
    }
    this.adminService.getRegulatoryFilingHistories(_params).subscribe(res => {
      if (res.data) {
        this.histories = res.data;
        this.histories.forEach(his => {
          if (!his.comment) his.comment = '';
        });
        this.historiesTotal = res.total;
      }
    }, error => {
      let mes = error.message ? error.message : error;
      SwalService.error(mes);
    })
  }

  pageChangeRequest(event) {
    this.reqPageSize = event.pageSize;
    this.reqPageOffset = event.pageIndex * event.pageSize;
    this.getRegulatoryFiling(this.reqPageOffset, this.reqPageSize, this.defaultSort);
  }

  pageChangeHistories(event) {
    this.historiesPageSize = event.pageSize;
    this.historiesPageOffset = event.pageIndex * event.pageSize;
    this.getRegulatoryHistories(this.historiesPageOffset, this.historiesPageSize, this.defaultSort);
  }

  submitRequest() {
    let _params = this.form.value;
    this.adminService.putRegulatoryFiling(_params).subscribe(res => {
      window.location.reload();
    }, error => {
      let mes = error.message ? error.message : error;
      SwalService.error(mes);
    })
  }

  checkShowRequestBtn() {
    if (
      this.data.status === Constants.RegulatoryStatus.FOR_VALIDATION ||
      this.data.status === Constants.RegulatoryStatus.ACCEPTED
    ) {
      return false;
    }
    return true;
  }

  // SORT Request
  sortRequests({ active, direction }) {
    if (direction === '') {
      this.sortRequests({ active: 'date', direction: 'desc' });
    } else {
      switch (active) {
        case 'date':
          this.sortByReqDate('request_date', direction);
          break;
        case 'from':
          this.sortByReqDate('start_date', direction);
          break;
        case 'to':
          this.sortByReqDate('end_date', direction);
          break;
        case 'status':
          this.sortByReq('status_name', direction);
          break;
        case 'uen':
          this.sortByReqDate('uen', direction);
          break;
        case 'tradeweb_id':
          this.sortByReq('tradeweb_id', direction);
          break;
      }
    }
  }
  sortByReq(prop, direction): void {
    this.requests = [
      ...this.requests.sort((a, b) => {
        return direction === 'asc'
          ? a[prop] > b[prop]
            ? 1
            : a[prop] < b[prop]
            ? -1
            : 0
          : a[prop] > b[prop]
          ? -1
          : a[prop] < b[prop]
          ? 1
          : 0;
      }),
    ];
  }
  sortByReqDate(prop, direction): void {
    this.requests = [
      ...this.requests.sort((a, b) => {
        let timeA = new Date(a[prop]).getTime();
        let timeB = new Date(b[prop]).getTime();
        return direction === 'asc'
          ? timeA > timeB
            ? 1
            : timeA < timeB
            ? -1
            : 0
          : timeA > timeB
          ? -1
          : timeA < timeB
          ? 1
          : 0;
      }),
    ];
  }

  // SORT Histories
  sortHistories({ active, direction }) {
    if (direction === '') {
      this.sortHistories({ active: 'date', direction: 'desc' });
    } else {
      switch (active) {
        case 'comment':
          this.sortByHis('comment', direction);
          return;
        case 'status':
          this.sortByHis('history_info.status_name', direction);
          return;
        case 'date':
          this.sortByHisDate('history_info.request_date', direction);
          return;
        case 'update':
          this.sortByHisDate('created_date', direction);
          return;
      }
    }
  }
  sortByHis(prop, direction): void {
    this.histories = [
      ...this.histories.sort((a, b) => {
        let _props = (prop as string).split('.');
        let _a, _b;
        if (_props.length > 1) {
          _a = a[_props[0]][_props[1]];
          _b = b[_props[0]][_props[1]];
        } else {
          _a = a[prop];
          _b = b[prop];
        }
        return direction === 'asc'
          ? _a > _b
            ? 1
            : _a < _b
            ? -1
            : 0
          : _a > _b
          ? -1
          : _a < _b
          ? 1
          : 0;
      }),
    ];
  }
  sortByHisDate(prop, direction): void {
    this.histories = [
      ...this.histories.sort((a, b) => {
        let _props = (prop as string).split('.');
        let timeA, timeB;
        if (_props.length > 1) {
          timeA = new Date(a[_props[0]][_props[1]]).getTime();
          timeB = new Date(b[_props[0]][_props[1]]).getTime();
        } else {
          timeA = new Date(a[prop]).getTime();
          timeB = new Date(b[prop]).getTime();
        }
        return direction === 'asc'
          ? timeA > timeB
            ? 1
            : timeA < timeB
            ? -1
            : 0
          : timeA > timeB
          ? -1
          : timeA < timeB
          ? 1
          : 0;
      }),
    ];
  }

}
